export default __webpack_public_path__ + "static/media/logo-white.d5d2f87d.svg";